<template>
    <div class="uk-padding uk-background-secondary uk-light">
        <div class="uk-container">
            <h2 class="uk-heading-line"><span>A Success Story</span></h2>
            <div class="uk-panel">
                <img class="uk-align-left@m uk-margin-remove-adjacent" src="../../../../assets/grad.jpg"
                     style="max-width: 400px; max-height: 400px; width: auto; height: auto; border-radius: 10px" alt="Example image">
                <p>Name: Greogery St. George Hewitt</p>
                <p>Degree: Master of Arts in Educational Administration (Leadership)</p>
                <p>Position: Interim Principal - Llandilo School of Special Education.</p>
                <p>
                    I started the Northern Caribbean University Master of Arts in Education Administration 
                    Leadership and attended orientation  twice; January 2013 and January 2019. With all that 
                    I have lost I never lose sight of God in my life. Our destiny is not in accolades and 
                    prizes but Jeremiah 29:11 reminded me. "I know the plans that I have towards you..." I 
                    was doing well but I stopped, I gave up I failed. During my summer courses I began to 
                    struggle financially and emotionally. I began to lose focus. I stopped doing my assignments, 
                    I lost faith in myself because my challenges were overbearing. The eventuality hit me when I 
                    could not complete my summer courses because mentally I could not manage.
                </p>
                <p>
                    If you have to stop your program remember anywhere you stop that is where you will have to 
                    begin and trust me it will be harder the next time around and even greater when the years 
                    becomes six.
                </p>
                <p>
                    I returned to NCU to complete my Masters of Arts in Education Administration and Leadership 
                    in 2019. My intention was to finish this program.  I came with one determination and that 
                    was to get another experience, my main concern is not about grades I just want to know how 
                    to Master my subject matter.
                </p>
                <p>
                    There were times when I questioned everything, everyone and even God while I was here in this 
                    university. I cried until my tears stopped flowing. I have seen so many rise to greatness 
                    and questioned myself but God made a way that is my way. One of my greatest joy is to be able 
                    to conduct my own School Improvement Plan from start to finish and feel confident to know that 
                    when it comes to Human Resources Administration I am not afraid because I am prepared by some 
                    of the best facilitators this world has ever seen. Even as I speak some are asleep but I know 
                    that my success story is now amongst some of the greatest of all time. I recommending to 
                    everyone, if you are seeking the best university to do your studies, enroll with NCU because 
                    here faith and learning is never separated. Talk about starting a class with a passage of 
                    scripture and that same passage can be used to bring out the content needed in the course 
                    outline that's NCU the Beacon on the hill. Thank you once again NCU.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "elSuccessStory"
    }
</script>

<style scoped>

</style>